<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Kidney Specific Details EMR-Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="stagedKidney"
              disabled
              label="Staged Kidney"
            />
          </div>
        </div>
    

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="kidneyPairedDonation"
              disabled
              label="Kidney Paired Donations"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="preEmptive"
              disabled
              label="Pre-Emptive"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "KidneySpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      stagedKidney: this.getStagedKidney( this.patientBundle ),
      kidneyPairedDonation: this.getKidneyPairedDonation( this.patientBundle ),
      preEmptive: this.getPreEmptive( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataBooleanCheckedLabel( patientBundle, observationCode ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return;
      }
      const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
      if( !match[0] ) {
        return;
      }
      return _.get( match[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';
    },
    getStagedKidney( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3995' );
    },
    getKidneyPairedDonation( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3996' );
    },
    getPreEmptive( patientBundle ) {
      return this.getSmartdataBooleanCheckedLabel( patientBundle, 'UHN#3567' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
